import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import ChevronDown from 'components/shared/chevron-down';
import ChevronUp from 'components/shared/chevron-up';
import { getCountryByLocale } from 'lib/shopify';
import styles from './countrySelect.module.scss';

export default function CountrySelect({ shippingCountries, formState, setFormState, locale }) {
  const countryByLocale = getCountryByLocale(locale);
  const [selectCountry, setSelectCountry] = useState(
    shippingCountries?.find(
      country => country?.toLowerCase() === countryByLocale.toLowerCase() || country === 'Nederland'
    )
  );

  useEffect(() => {
    setFormState({ ...formState, country: selectCountry });
  }, [selectCountry]);

  const [activeDropdown, setActiveDropdown] = useState(false);

  return (
    <>
      <div
        className={styles.confirmationButtonContent}
        onClick={() => setActiveDropdown(!activeDropdown)}
        role="none"
      >
        <button type="button" className={cn(styles.button, styles.resetMargin)}>
          {selectCountry}
        </button>
        <div className={styles.chevronContainer}>
          {activeDropdown ? (
            <ChevronUp width="2rem" height="2rem" />
          ) : (
            <ChevronDown width="2rem" height="2rem" />
          )}
        </div>
      </div>

      {activeDropdown && (
        <ul className={styles.locationsContainer}>
          {shippingCountries
            ?.filter(
              country =>
                country?.toLowerCase() === countryByLocale?.toLowerCase() || country === 'Nederland'
            )
            .map(country => (
              <li
                className={styles.countrySelector}
                role="none"
                value={selectCountry}
                onClick={() => {
                  setSelectCountry(country);
                  setActiveDropdown(!activeDropdown);
                }}
              >
                {country}
              </li>
            ))}
        </ul>
      )}
    </>
  );
}
